module.exports = __webpack_public_path__ + "static/media/26.451cc026.jpg";